import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ParametrosService {
  constructor(private http: HttpClient) {}

  getParameters(id_tipo_parametro): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all',
        id_tipo_parametro: id_tipo_parametro,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
    return this.http.post(`${apiUrl.BASE_URL}/parameters`, body);
  }
  getTypeParameters(): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all_type_param',
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
    return this.http.post(`${apiUrl.BASE_URL}/parameters`, body);
  }

  private handleError(errorResponse: HttpErrorResponse) {
    return throwError(errorResponse);
  }
}
